<template lang="html">
    <div id="operations" class="center-panel">
        <md-content class="md-elevation-1" md-theme="white" v-loader-overlay="false">
            <sort-table
                v-bind:columns="tableColumns" v-model="operations" @refresh="getOperations" v-bind:per-page="perPage" link
                v-bind:total="operationsAmount" v-on:create="addOperation"
                v-bind:noBreackColumns="['date', 'payment_number', 'ones_id', 'sum']" table-id="operations"
            >
                <template slot="sum" slot-scope="scope">{{ scope.item.sum ? (priceFormat(scope.item.sum) + ' руб.') : '0 руб.' }}</template>
                <template slot="company"  slot-scope="scope">{{ scope.item.company  ? scope.item.company.name  : ''}}</template>
                <template slot="customer" slot-scope="scope">{{ scope.item.customer ? scope.item.customer.name : ''}}</template>
                <template slot="type" slot-scope="scope">
                    <span v-bind:style="'color: ' + ((scope.item.type == 1) ? '#009688' : '#FF5252')"> {{ (scope.item.type == 1) ? 'Приход' : 'Расход' }} </span>
                </template>

                <template slot="date" slot-scope="scope">
                    <span>{{ ((scope.item.date) ? moment(scope.item.date).format('DD.MM.YYYY HH:mm:ss') : '') }}</span>
                </template>

                <template slot="created_at" slot-scope="scope">
                    <span>{{ ((scope.item.created_at) ? moment(scope.item.created_at).format('DD.MM.YYYY HH:mm:ss') : '') }}</span>
                </template>

                <template slot="updated_at" slot-scope="scope">
                    <span>{{ ((scope.item.updated_at) ? moment(scope.item.updated_at).format('DD.MM.YYYY HH:mm:ss') : '') }}</span>
                </template>

                <template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" v-on:click.stop.prevent="onRemove(scope.item.id)" danger-light rounded></z-icon-button>
                </template>
            </sort-table>
        </md-content>
    </div>
</template>
<script>
    import ZIconButton  from '@/components/ZIconButton.vue';
    import SortTable from "@/components/SortTable";
    import priceFormat from "@/mixins/priceFormat";
    export default {
        components: {SortTable, ZIconButton},
        data() {
            return {
                priceFormat: priceFormat,
                tableColumns: [
                    { label: '№ CRM', field: 'payment_number', sortable: true },
                    { label: '№ 1C',  field: 'ones_id', sortable: true },
                    { label: 'Дата',  field: 'date', sortable: true},
                    { label: 'Дата создания',   field: 'created_at', sortable: true},
                    { label: 'Дата обновления', field: 'updated_at', sortable: true},
                    { label: 'Получатель', field: 'company'},
                    { label: 'Контрагент', field: 'customer'},
                    { label: 'Сумма',      field: 'sum', sortable: true},
                    { label: 'Тип',        field: 'type'},
                    { label: '', field: 'actions' },
                ],
                title: 'Операции',
                progressKey: 'get-finances-list',
                perPage: 50
            }
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             * @returns Boolean
             */
            progress() {
                return this.progressObj[this.progressKey];
            },
            /**
             * Объект с флагами загрузи
             * @returns Object
             */            
            progressObj() {
                return this.$store.state.progressObj;
            },
            /**
             * Массив с фин. операциями
             * @returns Array
             */
            operations() {
                return this.$store.state.finance.operations.map(operation => {
                    operation.date = (operation.date) ? operation.date : null;                    
                    operation.routerLink = { name: 'Operation', params: {operation_id: operation.id}, query: this.$route.query };
                    return operation;
                });
            },
            /**
             * Кол-во фин. операций всего
             * @returns Number
             */
            operationsAmount() {
                return this.$store.state.finance.operations_amount
            },
            /**
             * Кол-во страниц
             * @returns Number
             */
            totalPages() {
                return Math.ceil(this.operationsAmount / this.perPage)
            },
        },
        watch: {
            '$route.name'(name) {
                if (name == 'Operations') this.init();
            }
        },
        methods: {
            /**
             * Инициализация компонента
             */
            init() {
                this.$store.commit('setTitle', 'Финансы');
            },
            /**
             * Модальное окно с подтверждением удаления фин. операции
             */
            onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении записи?', 'Действие необратимо!',
                    () => this.removeOperation(id)
                );
            },
            /**
             * Переводит пользователя на страницу добавления фин. записи
             */
            addOperation() {
                this.$router.push({ name: 'Operation', params: {operation_id: 'new'}});
            },
            /**
             * Удаляет фин. запись
             * @param Number id - ID фин. операции
             */
            removeOperation(id) {
                if (!id) return;
                this.$store.commit('showProgressBar', this.progressKey);
                this.$store.dispatch('finance/removeOperation', id)
                    .then(() => this.$root.$emit('refresh-table', 'operations'))
                    .finally(() => this.$store.commit('hideProgressBar', this.progressKey));
            },
            /**
             * Получает список фин. операций с бека
             * @param Number page       - Страница для запроса
             * @param Number count      - Кол-во элементов на странице
             * @param String orderBy    - Поле сортировки
             * @param String orderType  - Направление сортировки
             * @param Object filter     - Объект с фильтрацией
             */
            getOperations(page, count, orderBy, orderType) {
                this.$store.commit('showProgressBar', this.progressKey);

                let customFilter = {};
                if (this.$route.query && this.$route.query.custom_filter)
                    customFilter = JSON.parse(this.$route.query.custom_filter);

                this.$store.dispatch('finance/getOperations', {
                    order_by:   orderBy,
                    order_type: orderType,
                    filter:     this.resolveQueryFilter(),
                    page:       page,
                    count:      count,
                    symbol:     '%',
                    custom_filter: customFilter,
                }).finally(() => this.$store.commit('hideProgressBar', this.progressKey));
            },
            /**
             * Фильтрация
             */
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return null;
                let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), result = {model: [], relation: [], condition: 'or'};

                if (filter.search) {
                    result.model = [
                        ['ones_id', '%', filter.search], 'or',
                        ['payment_number', '%', filter.search], 'or',
                        ['description', '%', filter.search], 'or',
                    ]
                    result.relation = [
                        ['customer', 'inn',  '%', filter.search], 'or',
                        ['customer', 'passport_number', '%', filter.search], 'or',
                        ['customer', 'name', '%', filter.search], 'or',

                        ['company', 'inn', '%', filter.search], 'or',
                        ['company', 'name', '%', filter.search], 'or',
                    ]
                }

                return result;
            },
        }
    }
</script>
<style lang="sass"></style>



// WEBPACK FOOTER //
// Operations.vue?33566ce0